// extracted by mini-css-extract-plugin
module.exports = {"box":"Toggle_box__1UQtu","active":"Toggle_active__2CtA_","fadeIn":"Toggle_fadeIn__2ALxA","fadeOut":"Toggle_fadeOut__1UayP"};